import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Button from "components/CustomButtons/Button.js";
import Close from "@material-ui/icons/Close";
import classNames from "classnames";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import Radio from "@material-ui/core/Radio";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Tooltip from "@material-ui/core/Tooltip";

import {
	LoadingMgs,
	SuccessMessage,
	ErrorMessage,
} from "components/Common/toastify";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { post } from "../../../../lib/requests";
import Loading from "components/Common/loading";

const useStyles3 = makeStyles(javascriptStyles);
const useStyles2 = makeStyles(headersStyle);
const useStyles = makeStyles(basicsStyle);
const useCustomerDetailsStyles = makeStyles(customerDetailsStyles);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

const Country = [
	{
		code: "AU",
		name: "Australia",
	},
	{
		code: "CX",
		name: "Christmas Island",
	},
	{
		code: "CC",
		name: "Cocos (Keeling) Islands",
	},
	{
		code: "CK",
		name: "Cook Islands",
	},
	{
		code: "FJ",
		name: "Fiji",
	},
	{
		code: "IF",
		name: "French Southern Territories",
	},
	{
		code: "GU",
		name: "Guam",
	},
	{
		code: "HM",
		name: "Heard Island and McDonald Islands",
	},
	{
		code: "KI",
		name: "Kiribati",
	},
	{
		code: "MH",
		name: "Marshall Islands",
	},
	{
		code: "FM",
		name: "Micronesia",
	},
	{
		code: "NR",
		name: "Nauru",
	},
	{
		code: "NU",
		name: "Niue",
	},
	{
		code: "NF",
		name: "Norfolk Island",
	},
	{
		code: "MP",
		name: "Northern Mariana Islands",
	},
	{
		code: "PW",
		name: "Palau",
	},
	{
		code: "PG",
		name: "Papua New Guinea",
	},
	{
		code: "PN",
		name: "Pitcairn Islands",
	},
	{
		code: "SB",
		name: "Solomon Islands",
	},
	{
		code: "TK",
		name: "Tokelau",
	},
	{
		code: "TO",
		name: "Tonga",
	},
	{
		code: "TV",
		name: "Tuvalu",
	},
	{
		code: "WF",
		name: "Wallis and Futuna",
	},
];

const AccountAddDialog = ({
	accountAddDialog,
	setAccountAddDialog,
	emailPreviewData,
	setEmailPreviewData,
	setEmailPreview,
}) => {
	const classesModel = useStyles3();
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const classes2 = useStyles2();
	const classes3 = useStyles3();
	const [country, setCountry] = useState("AU");
	const [existmsid, setExistmsid] = useState(["yes", "no"]);
	const [existMicrosoftAccount, setExistMicrosoftAccount] = useState("no");
	const classesCustomerDetailsStyles = useCustomerDetailsStyles();
	const [selectBillingMethod, setSelectBillingMethod] = useState(
		"billtocustomer"
	);
	const [loadingDomain, setLoadingDomain] = useState(false);
	const [loading, setLoading] = useState(false);
	const [verifyDomain, setVerifyDomain] = useState("no");
	const classes = useStyles();

	const handleToggle = (value) => {
		const currentIndex = existmsid.indexOf(value);
		const newChecked = [...existmsid];

		if (currentIndex === -1) {
			newChecked.push(value);
			setValue("existmsid", "no");
			setExistMicrosoftAccount("no");
		} else {
			setValue("existmsid", "yes");
			setExistMicrosoftAccount("yes");
			newChecked.splice(currentIndex, 1);
		}
		setExistmsid(newChecked);
	};

	// form validation rules
	const validationSchema = Yup.object().shape({
		existmsid: Yup.string(),
		billing_method: Yup.string().required("Billing Method is required"),
		customer_no: Yup.string(),
		country: Yup.string().required("Country/region is required"),
		domain: Yup.string().required("Domain is required"),
		company: Yup.string().required("Company is required"),
		address1: Yup.string().when("existmsid", {
			is: (val) => val === "no",
			then: (schema) => schema.required("Address 1 is required"),
			otherwise: (schema) => schema.notRequired(),
		}),
		address2: Yup.string(),
		suburb: Yup.string().when("existmsid", {
			is: (val) => val === "no",
			then: (schema) => schema.required("Suburb is required"),
			otherwise: (schema) => schema.notRequired(),
		}),
		state: Yup.string().when("existmsid", {
			is: (val) => val === "no",
			then: (schema) => schema.required("State is required"),
			otherwise: (schema) => schema.notRequired(),
		}),
		postal: Yup.number()
			.transform((value, originalValue) => {
				// If the original value is an empty string, return undefined so Yup can treat it as "not set"
				return originalValue === "" ? undefined : value;
			})
			.when("existmsid", {
				is: (val) => val === "no",
				then: (schema) =>
					schema
						.required("Postal is required")
						.positive("Postal must be a positive number"),
				otherwise: (schema) => schema.notRequired(),
			}),

		firstname: Yup.string().required("First Name is required"),
		lastname: Yup.string().required("Last Name is required"),
		email: Yup.string().required("Email is required").email("Email is invalid"),
		phone: Yup.string().required("Phone is required"),
		verifyDomain: Yup.string().required("This domain name is not available"),
		reseller_contact_email: Yup.string().when("billing_method", {
			is: (val) => val === "billtoauscom",
			then: (schema) => schema.required("Reseller Contact Email is required"),
			otherwise: (schema) => schema.notRequired(),
		}),

		end_contact_email: Yup.string().when("billing_method", {
			is: (val) => val === "billtoauscom",
			then: (schema) => schema.required("End Contact Email is required"),
			otherwise: (schema) => schema.notRequired(),
		}),
	});
	const formOptions = { resolver: yupResolver(validationSchema) };

	// get functions to build form with useForm() hook
	const {
		register,
		handleSubmit,
		setError,
		trigger,
		setValue,
		clearErrors,
		reset,
		getValues,
		formState,
	} = useForm(formOptions);
	const { errors } = formState;

	async function onSubmit(formField) {
		setLoading(true);
		LoadingMgs("Create Customer", "processing...");
		const formField_ = getValues();
		try {
			await post(`/api/customers/createtenant`, formField_, true)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Create Customer", res.data.records.message);
						window.scrollTo(0, 0);
						document.body.scrollTop = 0;
						reset();
						setAccountAddDialog(false);
					} else {
						ErrorMessage("Create Customer", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Create Customer", message);
					setLoading(false);
				});
		} catch (error) {
			console.log("error", error);
			ErrorMessage("Create Customer", "Something went wrong try again!!");
			setLoading(false);
		}
	}

	const getDomainVerify = async (domain) => {
		setLoadingDomain(true);
		clearErrors("verifyDomain");
		setVerifyDomain("no");
		setValue("verifyDomain", "");
		const existMsid = getValues("existmsid");
		try {
			await post(
				`/api/customers/checkexistdomain`,
				{
					domain: domain,
					existmsid: existMsid,
				},
				true
			)
				.then((res) => {
					if (res.data.success) {
						setValue("verifyDomain", res.data.records.message);
						clearErrors("verifyDomain");
						setVerifyDomain(res.data.message);
						setValue("verifyDomain", "yes");
					} else {
						setError("verifyDomain", {
							type: "manual",
							message: res.data.message,
						});
						setVerifyDomain("no");
						setValue("verifyDomain", "");
					}
					setLoadingDomain(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Domain Verify", message);
					setLoadingDomain(false);
				});
		} catch (error) {
			ErrorMessage("Domain Verify", "Something went wrong try again!!");
			setLoadingDomain(false);
		}
	};

	const getPreviewEmail = async () => {
		const formField = getValues();
		const isValid = await trigger(); // validate all fields
		// check if the form has errors
		if (isValid === false) {
			return;
		}
		setLoading(true);
		try {
			await post(`/api/customer/previewemail`, formField, true)
				.then((res) => {
					if (res.data.success) {
						setEmailPreviewData(res.data.records);
						setEmailPreview(true);
					} else {
						ErrorMessage("Preview Email", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Preview Email", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Preview Email", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	return (
		<Dialog
			classes={{
				root: classes3.modalRoot,
				paper: classes3.modal + " " + classes3.createCustomerModal,
			}}
			open={accountAddDialog}
			TransitionComponent={Transition}
			keepMounted
			onClose={() => setAccountAddDialog(false)}
			aria-labelledby="classic-modal-slide-title"
			aria-describedby="classic-modal-slide-description">
			<DialogTitle
				id="classic-modal-slide-title"
				disableTypography
				className={classNames(
					classes3.container,
					classes3.modalHeader,
					classes3.dialogTitle
				)}>
				<Button
					simple
					className={classes3.modalCloseButton}
					key="close"
					aria-label="Close"
					onClick={() => setAccountAddDialog(false)}>
					{" "}
					<Close className={classes3.modalClose} />
				</Button>
				<h4 className={classNames(classes3.modalTitle)}>Account info</h4>
			</DialogTitle>
			<DialogContent
				id="classic-modal-slide-description"
				className={classes3.modalBody}>
				{/* <hr /> */}

				{loading && <Loading width={30} height={30} className={classes2.loading} />}

				<form
					onSubmit={handleSubmit(onSubmit)}
					id="accountUpdateForm"
					className={loading ? classesModel.opacity : ""}>
					<GridContainer>
						<GridItem
							xs={12}
							sm={12}
							md={12}
							className={classNames(
								classes2.customInputAdd,
								classesCustomerDetailsStyles.mT20
							)}>
							<div className={classNames(classes2.labelTitleMain)}>
								Select Billing Method
							</div>
						</GridItem>
						<GridItem
							xs={12}
							sm={4}
							md={4}
							lg={4}
							className={classes2.customInputAdd}>
							<FormControlLabel
								control={
									<Radio
										checked={selectBillingMethod === "billtocustomer"}
										onChange={() => {
											setValue("billing_method", "billtocustomer");
											setSelectBillingMethod("billtocustomer");
										}}
										value="billtocustomer"
										name="radio button enabled"
										aria-label="billtocustomer"
										icon={<FiberManualRecord className={classes.radioUnchecked} />}
										checkedIcon={<FiberManualRecord className={classes.radioChecked} />}
										classes={{
											checked: classes.radio,
											root: classes.radioRoot,
										}}
									/>
								}
								classes={{
									label: classes.label,
									root: classes.labelRoot,
								}}
								label="I will bill the customer"
							/>
							<input
								type="hidden"
								{...register("billing_method")}
								value={selectBillingMethod}
							/>
						</GridItem>
						<GridItem
							xs={12}
							sm={6}
							md={6}
							lg={6}
							className={classes2.customInputAdd}>
							<FormControlLabel
								control={
									<Radio
										checked={selectBillingMethod === "billtoauscom"}
										onChange={() => {
											setValue("billing_method", "billtoauscom");
											setSelectBillingMethod("billtoauscom");
										}}
										value="billtoauscom"
										name="billtoauscom"
										aria-label="billtoauscom"
										icon={<FiberManualRecord className={classes.radioUnchecked} />}
										checkedIcon={<FiberManualRecord className={classes.radioChecked} />}
										classes={{
											checked: classes.radio,
											root: classes.radioRoot,
										}}
									/>
								}
								classes={{
									label: classes.label,
									root: classes.labelRoot,
								}}
								label="Auscomp to bill the customer directly at my specified price."
							/>
						</GridItem>
						<GridItem xs={12} sm={6} md={6} className={classes2.customInputAdd}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Customer No. Your internal customer reference number{" "}
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("customer_no"),
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.customer_no?.message}
							</div>
						</GridItem>
						{selectBillingMethod === "billtoauscom" && (
							<>
								<GridItem
									xs={12}
									sm={12}
									md={12}
									className={classNames(
										classes2.customInputAdd,
										classesCustomerDetailsStyles.mT20
									)}>
									<div className={classNames(classes2.labelTitleMain)}>
										Direct Billing Details
									</div>
									<div className={classNames(classes2.description)}>
										Please enter in direct contact details for both yourself and the end
										user below. This will send an automated Payway setup email to the end
										user email address provided. If you wish to preview the email that
										will be sent to them, please click the button below.
									</div>
								</GridItem>
								<GridItem xs={12} sm={5} md={5} className={classes2.customInput}>
									<div className={classNames(classes2.labelTitleUpdate)}>
										Reseller Contact Email
									</div>
									<CustomInput
										inputProps={{
											placeholder: "Enter reseller contact email",
											...register("reseller_contact_email"),
										}}
										formControlProps={{
											fullWidth: true,
											className: classes2.formControl,
										}}
									/>
									<div
										className={classNames(
											"text-red-600 text-xs ml-3 pt-1 ",
											classes2.errorLabel
										)}>
										{errors.reseller_contact_email?.message}
									</div>
								</GridItem>
								<GridItem xs={12} sm={5} md={5} className={classes2.customInput}>
									<div className={classNames(classes2.labelTitleUpdate)}>
										End Contact Email
									</div>
									<CustomInput
										inputProps={{
											placeholder: "Enter end contact email",
											...register("end_contact_email"),
										}}
										formControlProps={{
											fullWidth: true,
											className: classes2.formControl,
										}}
									/>
									<div
										className={classNames(
											"text-red-600 text-xs ml-3 pt-1 ",
											classes2.errorLabel
										)}>
										{errors.end_contact_email?.message}
									</div>
								</GridItem>
								<GridItem
									xs={12}
									sm={2}
									md={2}
									className={classNames(
										classes2.customInput,
										classesCustomerDetailsStyles.mT20
									)}>
									<Button
										color="info"
										size="sm"
										onClick={getPreviewEmail}
										className={classes2.button}
										type="button">
										Preview Email
									</Button>
								</GridItem>
							</>
						)}
						<GridItem
							xs={12}
							sm={12}
							md={12}
							className={classNames(
								classes2.customInputAdd,
								classesCustomerDetailsStyles.mT20
							)}>
							<div className={classNames(classes2.labelTitleMain)}>Company</div>
						</GridItem>
						<GridItem
							xs={12}
							sm={12}
							md={12}
							className={classNames(
								classes2.customInputAdd,
								classesCustomerDetailsStyles.mB
							)}>
							<div
								className={
									classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal
								}>
								<FormControlLabel
									control={
										<Checkbox
											tabIndex={-1}
											onClick={() => handleToggle("yes")}
											checkedIcon={<Check className={classes.checkedIcon} />}
											icon={<Check className={classes.uncheckedIcon} />}
											classes={{
												checked: classes.checked,
												root: classes.checkRoot,
											}}
										/>
									}
									classes={{ label: classes.label, root: classes.labelRoot }}
									label="Does the customer have an existing Microsoft Account?"
								/>
							</div>
							<input
								type="hidden"
								{...register("existmsid")}
								value={existMicrosoftAccount}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.existmsid?.message}
							</div>
						</GridItem>
						<GridItem
							xs={12}
							sm={6}
							md={6}
							className={classNames(classes2.customInputAdd)}>
							<div
								className={classNames(
									classes2.labelTitleUpdate,
									classesCustomerDetailsStyles.mB
								)}>
								Country/region<span className="text-red-600 mr-2"> * </span> Why can't I
								see other countries/regions?{" "}
							</div>
							<FormControl fullWidth className={classes3.selectFormControl}>
								<InputLabel htmlFor="simple-select" className={classes3.selectLabel}>
									Select Country
								</InputLabel>
								<Select
									MenuProps={{
										className: classes3.selectMenu,
									}}
									classes={{
										select: classes3.select,
									}}
									value={country}
									inputProps={{
										id: "country",
										...register("country"),
										onChange: (e) => {
											setCountry(e.target.value);
											setValue("country", e.target.value);
											clearErrors("country");
										},
										disabled: existMicrosoftAccount === "yes" ? true : false,
									}}>
									{Country.map((item, index) => (
										<MenuItem
											key={index}
											classes={{
												root: classes3.selectMenuItem,
												selected: classes3.selectMenuItemSelected,
											}}
											value={item?.code}>
											{item?.name}
										</MenuItem>
									))}
								</Select>
							</FormControl>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.country?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Primary domain name <span className="text-red-600 mr-2"> * </span>{" "}
								<Tooltip
									id="tooltip-tina"
									title="This domain is used to create your customer's user accounts and email addresses. Choose a name similar to the company name, with no spaces or punctuation. The primary domain name can't be changed later."
									placement="top"
									classes={{ tooltip: classes.tooltip }}>
									<span className={classNames(classes2.tooltip)}> What is this?</span>
								</Tooltip>{" "}
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter primary domain name",
									...register("domain"),
									onBlur: (e) => {
										getDomainVerify(e.target.value);
										if (e.target.value.length === 0) {
											setVerifyDomain("no");
											setValue("verifyDomain", "");
										}
									},
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							{loadingDomain && (
								<Loading width={25} height={25} className={classes2.loading} />
							)}
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.domain?.message}
							</div>
							<input
								type="hidden"
								{...register("verifyDomain")}
								value={verifyDomain}
							/>
							{errors.verifyDomain?.message && (
								<div className={classNames(classes2.domainIsNotAvailable)}>
									{errors.verifyDomain?.message}
								</div>
							)}
							{verifyDomain !== "no" && (
								<div className={classNames(classes2.domainIsAvailable)}>
									{verifyDomain}
								</div>
							)}
						</GridItem>
						<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Company name <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter company name",
									...register("company"),
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.company?.message}
							</div>
						</GridItem>
						<GridItem
							xs={12}
							sm={4}
							md={4}
							className={classes2.customInput}></GridItem>
						<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Address line 1 <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("address1"),
									disabled: existMicrosoftAccount === "yes" ? true : false,
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.address1?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Address Line 2
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("address2"),
									disabled: existMicrosoftAccount === "yes" ? true : false,
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.address2?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Suburb <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									...register("suburb"),
									disabled: existMicrosoftAccount === "yes" ? true : false,
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.suburb?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								State/Province <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter state/province",
									...register("state"),
									disabled: existMicrosoftAccount === "yes" ? true : false,
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.state?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								ZIP/Postal code <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter zip/postal code",
									disabled: existMicrosoftAccount === "yes" ? true : false,
									...register("postal"),
									onChange: (e) => {
										clearErrors("postal");
									},
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.postal?.message}
							</div>
						</GridItem>
						<GridItem
							xs={12}
							sm={12}
							md={12}
							className={classNames(
								classes2.customInputAdd,
								classesCustomerDetailsStyles.mT20
							)}>
							<div className={classNames(classes2.labelTitleMain)}>
								Primary contact
							</div>
						</GridItem>
						<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								First name <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter first name",
									...register("firstname"),
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.firstname?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Last name <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter last name",
									...register("lastname"),
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.lastname?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Email address <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter email address",
									...register("email"),
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.email?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Phone number <span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter phone number",
									...register("phone"),
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.phone?.message}
							</div>
						</GridItem>
					</GridContainer>
				</form>
			</DialogContent>
			<DialogActions className={classes3.modalFooter}>
				{/* <Button
					color="info"
					size="sm"
					form="accountUpdateForm"
					className={classes2.button}
					type="submit"
					disabled={formState.isSubmitting}>
					Create
				</Button> */}
				<button
					disabled={formState.isSubmitting}
					type="submit"
					form="accountUpdateForm"
					className={classNames(classesCSStyles?.buttonPrimary)}>
					Create
				</button>
				<Button
					color="danger"
					size="sm"
					disabled={loading}
					onClick={() => {
						setAccountAddDialog(false);
					}}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AccountAddDialog;
